/* Le Grom — backorder + low-stock disclosure logic. Pairs with snippets/lg-backorder.liquid.
   Toggles the backorder pill/note, the low-stock line, and the cart property based on the
   selected variant's live inventory. Three independent update hooks for robustness. */
(function () {
  var LOW_THRESHOLD = 3; // keep in sync with lg_low_threshold in the snippet

  function initRoot(root) {
    if (!root || root.__lgBoInit) return;
    var dataEl = root.querySelector('.lg-bo-data');
    var disclosure = root.querySelector('.lg-bo');
    var lowEl = root.querySelector('.lg-lowstock');
    var prop = root.querySelector('.lg-bo-prop');
    if (!dataEl || !prop) return;

    var map;
    try { map = JSON.parse((dataEl.textContent || '').trim()); } catch (e) { return; }
    root.__lgBoInit = true;
    if (lowEl && lowEl.getAttribute('data-lg-threshold')) {
      LOW_THRESHOLD = Number(lowEl.getAttribute('data-lg-threshold')) || LOW_THRESHOLD;
    }

    var idInput = root.querySelector('product-form input[name="id"]') ||
                  root.querySelector('.product-variant-id');
    var btnWrap = root.querySelector('.product-form__buttons');
    var vs = root.querySelector('variant-selects');

    function apply() {
      var id = idInput ? String(idInput.value) : null;
      var s = id ? map[id] : null;
      var bo = !!(s && s.t === true && s.p === 'continue' && Number(s.q) <= 0 && s.a === true);
      var low = !!(s && !bo && s.t === true && s.a === true && Number(s.q) > 0 && Number(s.q) <= LOW_THRESHOLD);
      if (disclosure) disclosure.hidden = !bo;
      prop.disabled = !bo;
      if (lowEl) {
        lowEl.hidden = !low;
        if (low) lowEl.textContent = 'Only ' + s.q + ' left in this size';
      }
    }

    apply();

    // Hook 1: Dawn pub/sub (literal channel name; harmless if subscribe is absent).
    try {
      if (typeof subscribe === 'function') {
        subscribe('variant-change', function () { setTimeout(apply, 0); });
      }
    } catch (e) {}

    // Hook 2 (primary, version-agnostic): Dawn rewrites the buttons region on every
    // variant change. Observing it catches the change regardless of theme version.
    if (btnWrap && 'MutationObserver' in window) {
      new MutationObserver(function () { apply(); })
        .observe(btnWrap, { childList: true, subtree: true, attributes: true });
    }

    // Hook 3: also react to the raw selector change as a backstop.
    if (vs) vs.addEventListener('change', function () { setTimeout(apply, 60); });
  }

  function boot() {
    var hosts = document.querySelectorAll('product-info');
    if (hosts.length) { Array.prototype.forEach.call(hosts, initRoot); }
    else { initRoot(document); }
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
